module.exports = __webpack_public_path__ + "static/media/cover.9ba3330f.png";